import { ViewDensity, ViewType } from "@common/types/views/views";
import {
    HistoryFinancialAccountDetailsColumn,
    HistoryFinancialAccountDetailsView,
} from "./historyFinancialAccountDetailsView";

export const defaultHistoryFinancialAccountDetailsView: HistoryFinancialAccountDetailsView =
    {
        type: ViewType.HISTORY_FINANCIAL_ACCOUNT,
        columns: [
            { id: HistoryFinancialAccountDetailsColumn.DATE },
            { id: HistoryFinancialAccountDetailsColumn.ACCOUNT_NAME },
            { id: HistoryFinancialAccountDetailsColumn.OLD_VALUE },
            { id: HistoryFinancialAccountDetailsColumn.NEW_VALUE },
        ],
        filters: {},
        options: {
            selection: true,
            density: ViewDensity.MD,
        },
    };
